import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[numericOnly]'
})
export class NumericOnlyDirective {

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    
    const allowedControlKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'Home', 'End', 'ArrowLeft', 'ArrowRight', 'Clear', 'Copy', 'Paste'
    ];

    if (allowedControlKeys.includes(event.key)) {
      return;
    }

    if (event.ctrlKey || event.metaKey) {
      return;
    }

    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
     event.preventDefault();

    const pastedText = event.clipboardData?.getData('text/plain') || '';

    if (/^[0-9]+$/.test(pastedText)) {
      document.execCommand('insertText', false, pastedText);
    }
  }
}
